import get from 'lodash/get';
import {
    getCurrentTimeAsUTC,
    getCurrentUrl,
    setCachedStorageValue,
    pushUniqueEventToDataLayer,
    pushEventToDataLayer,
    generateId
} from './utils';
import { createCartItems, getCartShopperInfo, getOrderContactInfo } from './cart';
import { getItemsTotal } from '../cartUtils';

const generateBasePayload = tenantId => ({
    device_id: setCachedStorageValue(window.localStorage, 'device_id', generateId()),
    session_id: setCachedStorageValue(window.sessionStorage, 'session_id', generateId()),
    timestamp: getCurrentTimeAsUTC(),
    tenant_id: tenantId
});

const generateCheckoutStartedPayload = (tenantId, cart = {}, storeUrl) => ({
    ...generateBasePayload(tenantId),
    checkout_started_data: {
        cart_items: createCartItems(cart.items, storeUrl),
        cart_value: getItemsTotal(cart.items),
        checkout_url: getCurrentUrl()
    }
});

const generateShopperInfoPayload = (tenantId, cart = {}) => ({
    ...generateBasePayload(tenantId),
    shopper_info: getCartShopperInfo(cart)
});

const generateShippingInfoPayload = (tenantId, cart = {}) => ({
    ...generateBasePayload(tenantId),
    shipping_method: get(cart, 'shippingMethod.name')
});

const generatePaymentMethodPayload = (tenantId, paymentMethod) => ({
    ...generateBasePayload(tenantId),
    payment_method: paymentMethod
});

const generatePurchasePayload = (tenantId, order = {}, storeUrl) => ({
    ...generateBasePayload(tenantId),
    product_purchase_data: {
        tax: order.taxAmount,
        shipping: order.shippingCost,
        transaction_revenue: order.grandTotal,
        transaction_id: order.id,
        products: createCartItems(get(order, 'cart.items'), storeUrl),
        customer_info: getOrderContactInfo(order),
        shipping_method: get(order, 'cart.shippingMethod.name'),
        payment_method: order.paymentMethod
    }
});

export const logPageView = (tenantId) => {
    pushUniqueEventToDataLayer('page_view', generateBasePayload(tenantId));
};

export const logCheckoutStarted = (tenantId, cart, storeUrl) => {
    pushUniqueEventToDataLayer('checkout_started', generateCheckoutStartedPayload(tenantId, cart, storeUrl));
};

export const logShopperInfo = (tenantId, cart) => {
    pushEventToDataLayer('shopper_info', generateShopperInfoPayload(tenantId, cart));
};

export const logShippingInfo = (tenantId, cart) => {
    pushEventToDataLayer('shipping_info', generateShippingInfoPayload(tenantId, cart));
};

export const logPaymentMethod = (tenantId, paymentMethod) => {
    pushEventToDataLayer('payment_method', generatePaymentMethodPayload(tenantId, paymentMethod));
};

export const logPurchase = (tenantId, order, storeUrl) => {
    pushUniqueEventToDataLayer('product_purchase', generatePurchasePayload(tenantId, order, storeUrl));
};



// WEBPACK FOOTER //
// ./src/app/services/dataLayer/index.js